import axios from "axios";
import { runtimeConfig } from "@/lib/config";

export const API = `${runtimeConfig.backendUrl}/api`;
export const api = axios.create({ baseURL: API, timeout: 20_000 });
export const buyerApi = axios.create({ baseURL: API, timeout: 20_000 });
export const partnerApi = axios.create({ baseURL: API, timeout: 20_000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aureon_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Request-ID"] = globalThis.crypto?.randomUUID?.() || `web-${Date.now()}`;
  return config;
});

buyerApi.interceptors.request.use((config) => { const token=localStorage.getItem("aureon_buyer_token"); if(token)config.headers.Authorization=`Bearer ${token}`; return config; });
partnerApi.interceptors.request.use((config) => { const token=localStorage.getItem("aureon_partner_token"); if(token)config.headers.Authorization=`Bearer ${token}`; return config; });

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes("/auth/login");
    if (error.response?.status === 401 && !isLoginRequest) {
      window.dispatchEvent(new CustomEvent("aureon:auth-expired"));
    }
    return Promise.reject(error);
  },
);

export function formatApiErrorDetail(detail, error) {
  if (!detail && error?.code === "ECONNABORTED") return "The request timed out. Please try again.";
  if (!detail && !error?.response) return "We could not reach the server. Check your connection and try again.";
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((entry) => (entry && typeof entry.msg === "string" ? entry.msg : null))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "Something went wrong. Please try again.";
}

export async function reportClientError(error, context = {}) {
  const stack = [error?.stack, context.componentStack].filter(Boolean).join("\n");
  const payload = {
    message: String(error?.message || error || "Unknown client error").slice(0, 500),
    stack: stack ? String(stack).slice(0, 4000) : null,
    path: context.path || window.location.pathname,
    user_agent: navigator.userAgent.slice(0, 500),
  };
  try {
    await fetch(`${API}/monitoring/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // Error reporting must never trigger another visible application error.
  }
}
